import { PURCHASE_STATUS } from "../enums/PurchaseStatus";
import { PURCHASE_TYPE } from "../enums/PurchaseType";
import { DELIVERY_ORDER_STATUS } from "../enums/DeliveryOrderStatus";
import { dateHasExpired } from "./DateTimeUtils";

export const getPurchaseStatusName = (status) => {
  switch (status) {
    case PURCHASE_STATUS.DRAFT:
      return "Borrador";
    case PURCHASE_STATUS.PENDING_APPROVAL:
      return "Pendiente de Aprobación";
    case PURCHASE_STATUS.ERROR:
      return "Error";
    case PURCHASE_STATUS.PAID:
      return "Pagado";
    case PURCHASE_STATUS.DELIVERED:
      return "Entregado";
    case PURCHASE_STATUS.REFUNDED:
      return "Cobro devuelto";
    default:
      return "";
  }
};

export const getPurchaseDeliveryStatusName = (status) => {
  switch (status) {
    case DELIVERY_ORDER_STATUS.UNCONFIRMED:
      return "Pendiente de aprobación";
    case DELIVERY_ORDER_STATUS.GENERATED:
      return "Orden recibida";
    case DELIVERY_ORDER_STATUS.ACCEPTED:
      return "En preparación";
    case DELIVERY_ORDER_STATUS.READY:
      return "Pedido en camino";
    case DELIVERY_ORDER_STATUS.DELIVERED:
      return "Pedido entregado";
    case DELIVERY_ORDER_STATUS.CANCELED:
      return "Pedido cancelado";
    default:
      return "";
  }
};

export const isPurchaseExpired = (purchase) => {
  return purchase.offerClosingDeliveryDate
    ? purchase.status === PURCHASE_STATUS.PAID &&
        dateHasExpired(purchase.offerClosingDeliveryDate)
    : true;
};

export const isPurchaseDelivered = (purchase) => {
  return purchase?.status === PURCHASE_STATUS.DELIVERED;
};

export const purchaseCanBeRefunded = (purchase) => {
  return [PURCHASE_STATUS.PAID, PURCHASE_STATUS.DELIVERED].includes(
    purchase?.status
  );
};

export const getPurchaseTotalItems = (purchase) => {
  return purchase?.productsData?.reduce(
    (acc, product) => acc + product.quantity,
    0
  );
};

export const isPurchaseMultipleProducts = (purchase) =>
  getPurchaseTotalItems(purchase) > 1;

export const isDeliveryPurchase = (purchase) =>
  purchase?.type === PURCHASE_TYPE.DELIVERY;
